import { Component, Input, OnInit } from '@angular/core'
import { Discussion } from '../../../../shared/interfaces/discussion.interface'

import { BreadcrumbLink } from 'src/app/shared/interfaces/breadcrumb-link.interface'
import { ExpertGroupPortal } from 'src/app/shared/interfaces/expert-group-portal.interface'
import { TaxonomyTerm } from 'src/app/shared/interfaces/taxonomy-term.interface'
import { AreaService } from 'src/app/shared/services/area.service'
import { TagService } from 'src/app/shared/services/tag.service'
import { BreadcrumbService } from '../../../../shared/services/breadcrumb.service'
import { DiscussionService } from '../../services/discussion.service'

@Component({
  selector: 'app-expert-group-portal-header',
  templateUrl: './expert-group-portal-header.component.html',
  styleUrls: ['./expert-group-portal-header.component.scss']
})
export class ExpertGroupPortalHeaderComponent implements OnInit {
  @Input() selectedNavItem: string
  @Input() expertGroupPortal: ExpertGroupPortal

  breadcrumbLinks: BreadcrumbLink[]

  hasDiscussions: boolean
  hasData: boolean

  loading: boolean
  constructor(
    private breadcrumbService: BreadcrumbService,
    private discussionService: DiscussionService,
    private tagService: TagService,
    private areaService: AreaService
  ) {}

  async ngOnInit(): Promise<void> {
    // TODO: Use CapitalizePipe instead of this.
    const capitalizedNavItem =
      this.selectedNavItem.charAt(0).toUpperCase() +
      this.selectedNavItem.slice(1)

    this.breadcrumbLinks = this.breadcrumbService.getBreadCrumbLinks(
      this.expertGroupPortal.breadcrumbSlug,
      [
        {
          label: capitalizedNavItem,
          path: `${this.expertGroupPortal.baseUrl}/${this.selectedNavItem}`
        }
      ]
    )

    const tagPromises: Promise<TaxonomyTerm>[] =
      this.expertGroupPortal.tagSlugs.map((tagSlug) =>
        this.tagService.showBySlug(tagSlug)
      )

    this.loading = true
    Promise.all(tagPromises)
      .then((tags: TaxonomyTerm[]) => {
        // Get the discussions of the current expert group portal only when the tag ids are ready.
        this.discussionService
          .listUnpaginated({
            tagIds: tags.map((tag: TaxonomyTerm) => tag.id)
          })
          .then((discussions: Discussion[]) => {
            this.hasDiscussions = discussions.length > 0

            // Get the data of the current expert group portal only when the area is ready.
            this.areaService
              .show(this.expertGroupPortal.slug + '-data')
              .then((area) => {
                this.hasData = area ? true : false
                this.loading = false
              })
              .catch(() => {
                this.hasData = false
                this.loading = false
              })
          })
      })
      .catch(() => {
        this.hasDiscussions = false
        this.loading = false
      })
  }
}
